import React, { useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import { edit } from '../../AlertsActions'

import Form from './Form'

const CreateEdit = props => {
  const editingAlert = useSelector(state => state.alerts.editingAlert)
  const history = useHistory()
  const dispatch = useDispatch()

  // Pode ser aberto por rota (/alerts/create-edit/:id) ou direto, via props
  const id = props.id || props.match.params.id
  const isEdit = id !== 'new'

  const handleClose = () => {
    if (props.onClose) return props.onClose()
    return history.push('/alerts')
  }

  useEffect(() => {
    if (isEdit) dispatch(edit(id))
  }, [id])

  return (
    <BaseFilterModal
      open
      hiddenHelpButton
      handleOpen={handleClose}
      paperWidth="820px"
      title={isEdit ? 'Editar Alerta' : 'Cadastrar Alerta'}
    >
      <Grid item xs={12}>
        {(!isEdit || editingAlert?.id == id) && (
          <Form
            edit={isEdit}
            data={isEdit ? editingAlert : null}
            id={id}
            handleClose={handleClose}
          />
        )}
      </Grid>
    </BaseFilterModal>
  )
}

export default CreateEdit
